"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  number: "01",
  eyebrow: "01 / Processamento",
  headline: "Revestimento & Aplicação",
  body: "Aplicação uniforme de óleos, coberturas e antiaderentes em linhas de alta velocidade, com controlo preciso do caudal",
  image: {
    src: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-04-as-16.27.58.png?v=4mghy8zk9sr",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-04-as-16.27.58.png?v=4mghy8zk9sr-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-04-as-16.27.58.png?v=4mghy8zk9sr-wvc-sizes",
    alt: "Sistema de aplicação e revestimento de precisão na indústria alimentar"
  },
  imageLeft: true
}, {
  number: "02",
  eyebrow: "02 / Processamento",
  headline: "Secagem por Pulverização",
  body: "Bicos de atomização para torres de secagem, garantindo granulometria consistente e eficiência energética",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/aplicacoes_industriais.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/aplicacoes_industriais.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/aplicacoes_industriais.png-wvc-sizes",
    alt: "Bicos de atomização para secagem por pulverização em processamento alimentar"
  },
  imageLeft: false
}, {
  number: "03",
  eyebrow: "03 / Processamento",
  headline: "Higienização & Lavagem de Tanques",
  body: "Cabeças rotativas de lavagem e sistemas CIP que reduzem consumo de água e tempo de paragem, assegurando conformidade com a segurança alimentar",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/inovacao_tecnologica.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/inovacao_tecnologica.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/inovacao_tecnologica.webp-wvc-sizes",
    alt: "Sistema de higienização e lavagem CIP de tanques em ambiente fabril alimentar"
  },
  imageLeft: true
}];
export default function Processamentoalimentosshowcase() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference) and (min-width: 768px)", () => {
      gsap.set(".bp-intro-eyebrow, .bp-intro-heading, .bp-intro-body", {
        y: 24
      });
      gsap.to(".bp-intro-eyebrow, .bp-intro-heading, .bp-intro-body", {
        opacity: 1,
        y: 0,
        duration: 0.72,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: {
          trigger: ".bp-intro",
          start: "top 85%",
          once: true
        }
      });
      const rows = gsap.utils.toArray<HTMLElement>(".bp-row");
      rows.forEach(row => {
        const image = row.querySelector(".bp-row-image");
        const text = row.querySelectorAll<HTMLElement>(".bp-row-numeral, .bp-row-eyebrow, .bp-row-headline, .bp-row-body, .bp-row-link");
        const frame = row.querySelector<HTMLElement>(".bp-row-frame");
        if (image) {
          gsap.to(image, {
            yPercent: -12,
            ease: "none",
            scrollTrigger: {
              trigger: row,
              start: "top bottom",
              end: "bottom top",
              scrub: 0.5
            }
          });
        }
        gsap.set(text, {
          y: 24
        });
        gsap.to(text, {
          opacity: 1,
          y: 0,
          duration: 0.72,
          ease: "power3.out",
          stagger: 0.1,
          scrollTrigger: {
            trigger: row,
            start: "top 70%",
            once: true
          }
        });
        if (frame) {
          ScrollTrigger.create({
            trigger: row,
            start: "top 50%",
            once: true,
            onEnter: () => {
              frame.classList.add("bp-frame-active");
            }
          });
        }
      });
      const halos = gsap.utils.toArray<HTMLElement>(".bp-halo");
      halos.forEach(halo => {
        gsap.to(halo, {
          scale: 1.04,
          opacity: 1,
          duration: 6,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1
        });
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(".bp-intro-eyebrow, .bp-intro-heading, .bp-intro-body, .bp-row-numeral, .bp-row-eyebrow, .bp-row-headline, .bp-row-body, .bp-row-link", {
        opacity: 1,
        y: 0
      });
    });
    mm.add("(prefers-reduced-motion: no-preference) and (max-width: 767px)", () => {
      gsap.set(".bp-intro-eyebrow, .bp-intro-heading, .bp-intro-body, .bp-row-numeral, .bp-row-eyebrow, .bp-row-headline, .bp-row-body, .bp-row-link", {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31146" id="processamentoalimentosshowcase" data-nav="dark" className="bg-background text-foreground py-32 md:py-44 overflow-hidden">
      <div ref={container} className="mx-auto max-w-[1440px] px-5 md:px-8">
        {/* Intro */}
        <div className="bp-intro mx-auto max-w-[720px] text-center">
          <span className="bp-intro-eyebrow inline-block text-xs uppercase tracking-[0.22em] font-medium" style={{
          opacity: 0,
          color: "var(--muted-foreground)"
        }}>
            Eurocontrol
          </span>
          <h2 className="bp-intro-heading mt-6 font-default font-normal leading-[1.02]" style={{
          opacity: 0,
          fontSize: "clamp(34px, 4.6vw, 68px)",
          letterSpacing: "-0.028em",
          color: "var(--foreground)"
        }}>
            Soluções para o processamento alimentar.
          </h2>
          <p className="bp-intro-body mt-6 font-default" style={{
          opacity: 0,
          fontSize: "clamp(17px, 1.15vw, 19px)",
          lineHeight: 1.5,
          color: "var(--foreground)"
        }}>
            Sistemas de pulverização e engenharia de precisão otimizados para garantir a máxima higiene, qualidade e eficiência na indústria alimentar.
          </p>
        </div>

        {/* Feature Blocks */}
        <div className="mt-24 md:mt-32 flex flex-col gap-24 md:gap-24">
          {features.map((feature, i) => <div key={i} data-index={i} className={`bp-row grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-24 items-center ${feature.imageLeft ? "" : "md:[&>*:first-child]:order-2"}`}>
              {/* Image Frame */}
              <div className="md:col-span-6 relative">
                <div className="bp-row-frame relative overflow-hidden rounded-xl transition-colors duration-500" style={{
              border: "1px solid var(--border)",
              backgroundColor: "var(--muted)"
            }}>
                  <div aria-hidden="true" className="bp-halo absolute inset-0 pointer-events-none" style={{
                opacity: 0.85,
                background: "radial-gradient(circle at 50% 50%, var(--accent) 0%, var(--accent) 30%, transparent 65%)",
                filter: "blur(60px)",
                transformOrigin: "center"
              }} />
                  <div className="bp-row-image relative aspect-[4/5] md:aspect-[5/6] w-full">
                    <img src={feature.image.src} data-wvc-srcset={feature.image.srcset} data-wvc-sizes={feature.image.sizes} alt={feature.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                  </div>
                </div>
              </div>

              {/* Text Block */}
              <div className="md:col-span-6">
                <div className="bp-row-numeral font-default font-light leading-[0.9]" style={{
              opacity: 0,
              fontSize: "clamp(56px, 6vw, 96px)",
              letterSpacing: "-0.045em",
              color: "var(--primary)"
            }}>
                  {feature.number}
                </div>
                <span className="bp-row-eyebrow mt-6 inline-block text-xs uppercase tracking-[0.22em] font-medium" style={{
              opacity: 0,
              color: "var(--muted-foreground)"
            }}>
                  {feature.eyebrow}
                </span>
                <h3 className="bp-row-headline mt-4 font-default font-medium" style={{
              opacity: 0,
              fontSize: "clamp(24px, 2.4vw, 34px)",
              letterSpacing: "-0.02em",
              lineHeight: 1.12,
              color: "var(--foreground)"
            }}>
                  {feature.headline}
                </h3>
                <p className="bp-row-body mt-6 max-w-[520px] font-default" style={{
              opacity: 0,
              fontSize: "clamp(15px, 1vw, 16px)",
              lineHeight: 1.55,
              color: "var(--muted-foreground)"
            }}>
                  {feature.body}
                </p>
                <div className="bp-row-link mt-8" style={{
              opacity: 0
            }}>
                  <Link to="/ContactsPage">
                    <Button variant="ghost" className="group h-auto px-0 py-2 bg-transparent hover:bg-transparent" style={{
                  color: "var(--foreground)"
                }}>
                      <span className="text-sm font-medium tracking-normal border-b border-transparent group-hover:border-current transition-colors duration-300 pb-0.5">
                        Saber mais
                      </span>
                      <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Button>
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <style>{`
        .bp-frame-active {
          border-color: var(--primary) !important;
        }
      `}</style>
    </section>;
}